import { css } from 'styled-components';

const markerColor =
  (skin) =>
  ({ theme }) =>
    theme.base.colorSchema[skin];

const stopMarkerStyles = css`
  .stopMarker {
    font-size: 10px;
    width: 24px;
    height: 24px;
    border-radius: 24px;
    opacity: 1;
    overflow: visible !important;

    &:after {
      content: '';
      display: block;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 12px 8px 0 8px;
      position: absolute;
      bottom: -12px;
      left: 50%;
      margin-left: -8px;
    }

    ${['error500', 'primary500'].map(
      (skin) => css`
        &__pickup__${skin} {
          background-color: #fff;
          border: 3px solid ${markerColor(skin)};
          color: var(--grey800);
          &:after {
            border-color: ${markerColor(skin)} transparent transparent transparent;
          }
        }

        &__dropoff__${skin} {
          background-color: ${markerColor(skin)};
          border: 3px solid ${markerColor(skin)};
          color: #fff;
          &:after {
            border-color: ${markerColor(skin)} transparent transparent transparent;
          }
        }
      `
    )};

    &__isMain {
      width: 36px;
      height: 36px;
      border-radius: 4px;

      &:after {
        border-width: 7px 4px 0 4px;
        position: absolute;
        bottom: -10px;
        margin-left: -4px;
      }
    }
  }
`;

export default stopMarkerStyles;
